const content = {
  component: 'PageTypeA',
  cssClass: 'page-two-c',
  meta: {
    title: 'YellowDog Fetches Computing Power When it’s Needed Most',
    description: `CERN is producing increasing amounts of data—and they need an effective solution to store it.`,
    og: {
      type: 'website',
      title: 'Harness the cloud, on demand—learn more',
      description: `YellowDog is adapting its cloud rendering service to help the finance & aerospace industries innovate.`,
		image: require('../../assets/images/social/og_page2-C.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'Learn how the cloud gives businesses an extra boost when they need it.',
      description: `YellowDog is already speeding up the process-heavy work of 1,400 computer animation and digital effects studios. Now they plan to bring the same cloud-based power to finance and aerospace.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_page2-C.jpg')
    }
  },
  title: 'YellowDog Fetches Computing Power When it’s Needed Most',
  heroImage: {
    preload: require('../../assets/images/backgrounds/p2c/page-two_c-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/p2c/page-two_c@2x.jpg')
  },
  sections: [
    {
      component: 'SectionCopy',
      content: {
        copy: `Converting hundreds of thousands of computer images to realistic digital animation taxes even the banks of servers deployed by specialist graphics studios. British startup YellowDog has devised a way to harness that processing to cloud computing services when clients need an extra boost to hit deadlines.`,
        type: 'intro'
      }
    },
    {
      component: 'SectionSeperator',
      content: {
        image: null
      }
    },
    {
      component: 'SectionCopy',
      content: {
        copy: `
          <p>The Bristol-based developer counts more than 1,400 computer animation and digital effects studios in 42 countries as customers for its software. This software can cut the time needed to render a computer-animated film to a couple of weeks compared with months when using only on-premises machines. Oracle’s Cloud Infrastructure plays a key role.</p>
          <p>“We use the biggest, most powerful machines Oracle has,” YellowDog founder and CEO Gareth Williams says. The fastest computers YellowDog taps into are two to nine times faster for CPU jobs than competitors’ cloud computing environments, according to the CEO, who founded the company nearly four years ago after a career in telecom. The graphics processing delivered in the cloud is 34 percent faster than others’ tools.</p>
          <p>“The price-performance ratio we get from Oracle is second to none,” says Gareth. That’s meant customers can get their jobs done faster.</p>
        `,
        type: 'default'
      }
    },
    {
      component: 'SectionQuote',
      content: {
        quote: `The price-performance ratio we get from Oracle is second to none`,
        author: `Gareth Quilliams`,
        position: `Founder and CEO, YellowDog`,
        type: 'quote',
        backgroundImage: require('../../assets/images/content/p2c/quote@2x.jpg')
      }
    },
    {
      component: 'SectionCopy',
      content: {
        copy: `
          <p>Now the company is applying its computation-routing technology to tough computing tasks in finance and aerospace.  YellowDog’s platform makes sure calculations performed by computers’ CPUs and graphics chips get done on time, and quotes customers a price before sending computations to the cloud.</p>
          <p>Demand for supersized server power is helping YellowDog expand its market to banks’ account reconciliations, trading simulations, regulatory stress-tests of capital reserves, and insurers’ anti-money laundering calculations. The batch computing jobs can be “burst” to the cloud so customers can tap additional power when it’s needed to complete them on time.</p>
          <p>“Anti money laundering analysis, for example, needs to be run daily yet can consume 30 hours of computing time. And many banks have thousands of servers running at only 3 percent of their total capacity,” Gareth says. Inefficient servers or computing jobs failing to yield overnight results can waste money or impair traders’ work the following day. “Both of those are a bit rubbish,” he adds. YellowDog released its banking software in 2018.</p>
        `,
        type: 'default'
      }
    },
    {
      component: 'SectionImage',
      content: {
        image: require('../../assets/images/content/p2c/image@2x.jpg'),
        alt: '',
        type: 'image'
      }
    },
    {
      component: 'SectionCopy',
      content: {
        copy: `
          <p>One of the exciting new projects YellowDog undertook was building and delivering training for machine learning models for an American credit bureau that lets its customer predict how long computing processes will take to run. That enables the customer to predict costs and avoid unnecessary hardware expenses, says financial services sales head Jamie Donald.</p>
          <p>YellowDog is also studying applications of its software in aerospace and defense for predicting maintenance needed on machines and modeling what’s likely to happen in battle, according to Jamie.</p>
        `,
        type: 'default'
      }
    },
    {
      component: 'SectionCallToActionFullWidth',
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          {
            image: require('../../assets/images/content/p2c/p2C-cta@2x.jpg'),
            copy: 'Try out our Oracle benefits calculator',
            url: 'https://www.oracle.com/uk/area-of-interest/it/tech-to-transform-your-business.html?source=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_IT_AW_HI_CM_UK_C11_Q22_WP&intcmp=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_IT_AW_HI_CM_UK_C11_Q22_WP',
            buttonCopy: 'Learn more'
          }
        ],
        type: 'cta'
      }
    }
  ]
}

export default content;